window.BUTCartNotificationPanel = window.BUTCartNotificationPanel || class BUTCartNotificationPanel extends BUTCustomComponent {
  constructor() {
    super();
    this.elms = {
      notification_wrapper: this.$(`.js-cart-notification-panel-wrapper`),
      close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
      notification_progress: this.$(`.js-cart-notification-progress`),
      notification_message: this.$(`.js-cart-notification-message`),
    };
    this.dismiss_timeout = null;
    this.element_to_focus = null;
    this.previousFocusedElement = null;
    for (let i = 0, n = this.elms.close_buttons.length; i < n; i++) {
      this.elms.close_buttons[i].addEventListener(
        "click",
        this.close.bind(this)
      );
    }
  }

  /**
   * bind event handler to web component elements
   */

  open() {
    this.dispatchEvent(new Event("opened"));
    this.togglePanel(true);
    setTimeout(() => {
      BUTHelper.trapFocus(this);
    });
  }

  close() {
    this.clearDismissTimeout();
    this.togglePanel(false);
    this.dispatchEvent(new Event("closed"));

    if (this.element_to_focus) {
      BUTHelper.removeTrapFocus(this.element_to_focus);
      this.element_to_focus = null;
    } else {
      BUTHelper.removeTrapFocus();
    }
  }

  clearDismissTimeout() {
    clearTimeout(this.dismiss_timeout);
  }

  renderQuantityContents(
    isOpenNoti = true,
    productQuantity,
    elementToFocus = null
  ) {
    this.element_to_focus = elementToFocus;
    if (productQuantity > 0) {
      if (productQuantity == 1) {
        this.elms.notification_message.textContent =
          BUTLanguage.cart_noti.MESSAGE_ONE_ITEM;
      } else {
        this.elms.notification_message.textContent =
          BUTLanguage.cart_noti.MESSAGE_MULTIPLE_ITEMS;
      }
      this.setDismissTimeout();
      this.elms.notification_progress.classList.remove("progress");
      setTimeout(() => {
        this.elms.notification_progress.classList.add("progress");
      }, 10);

      if (isOpenNoti) this.open();
    }
  }

  renderContents(
    response,
    isOpenNoti = true,
    elementToFocus = null,
    productQuantity
  ) {
    this.productId = response.id;
    this.element_to_focus = elementToFocus;
    if (productQuantity == 1) {
      this.elms.notification_message.textContent =
        BUTLanguage.cart_noti.MESSAGE_ONE_ITEM;
    } else {
      this.elms.notification_message.textContent =
        BUTLanguage.cart_noti.MESSAGE_MULTIPLE_ITEMS;
    }
    if (isOpenNoti) {
      this.setDismissTimeout();
    }
    this.elms.notification_progress.classList.remove("progress");
    setTimeout(() => {
      this.elms.notification_progress.classList.add("progress");
    }, 10);

    let sections = this.getSectionsToRender();
    for (let i = 0, n = sections.length; i < n; i++) {
      let element = BUTHelper.qs(sections[i].space_selector);
      if (element) {
        if (sections[i].space_selector == "#headerCartStatus") {
          element.classList.add("header-cart-status--animate");
        }

        element.innerHTML = this.getSectionInnerHTML(
          response.sections[sections[i].id],
          sections[i].selector
        );
      }
    }
    if (isOpenNoti) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "header-cart-status",
        section: "header-cart-status",
        space_selector: `#headerCartStatus`,
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  togglePanel(toggle) {
    if (toggle) {
      this.classList.add("show");
      this.removeAttribute("hidden");
    } else {
      this.classList.remove("show");
    }
    return;
  }

  setDismissTimeout() {
    clearTimeout(this.dismiss_timeout);
    this.previousFocusedElement = document.activeElement;
    this.dismiss_timeout = setTimeout(() => {
      this.close();
      if (this.previousFocusedElement)
        BUTHelper.trapFocus(this.previousFocusedElement);
    }, 3000);
  }
}

if (!customElements.get("but-cart-noti")) {
  customElements.define("but-cart-noti", window.BUTCartNotificationPanel);
}